export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// 🔍 DEBUG: Environment variables yüklendi mi kontrol et
console.log("🔐 Firebase Config Debug:");
console.log("  ✓ apiKey:", process.env.REACT_APP_FIREBASE_API_KEY ? "Loaded ✅" : "MISSING ❌");
console.log("  ✓ projectId:", process.env.REACT_APP_FIREBASE_PROJECT_ID ? "Loaded ✅" : "MISSING ❌");
console.log("  ✓ authDomain:", process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? "Loaded ✅" : "MISSING ❌");